import { render, staticRenderFns } from "./OrgTab.vue?vue&type=template&id=f9027464"
import script from "./OrgTab.ts?vue&type=script&lang=ts&external"
export * from "./OrgTab.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports